import { Typography } from "@mui/material";

const AppStageStatus = ({ ...props }) => {
  const appStatus = props.appStatus;
  const record = props.record;
  const appId = props.appId;
  let appBgColor = "";
  let appStage = "";
  let appStageStatus = "";
  let appStageAch = "";
  let appStageDisbursement = "";

  if (appStatus == "New" || appStatus == "Check" || appStatus == "restart") {
    appStage = "Under Review";
    if (record?.showNextprocess == 1) {
      appStageStatus = "Ready for Screening";
      appBgColor = "#1976d2";
    } else {
      appStageStatus = "Pending Verification";
      appBgColor = "#fff1da";
    }
  } else if (appStatus == "Initial Review") {
    appStage = "Under Review";
    appStageStatus = "Ready for Initial Review";
    appBgColor = "#1976d2";
    // if (props?.requirementSaved == "yes") {
    //   appStageStatus = "";
    // } else {
    //   appStageStatus = "Pending Save";
    // }
  } else if (appStatus == "Final Review") {
    appStage = "Ready for Final Review";
    appBgColor = "#1976d2";
  } else if (appStatus == "To Notify") {
    appStage = "Ready for Notification";
    appBgColor = "#1976d2";
  } else if (
    appStatus == "counter" ||
    appStatus == "Countered" ||
    appStatus == "Pre-Approved" ||
    appStatus == "pre-approve"
  ) {
    appStage = "Countered and Pre-Approved";
    if (record.sApplicationResponse != "Accept") {
      appStageStatus = "Pending Acceptance";
      appBgColor = "#fff1da";
    } else {
      appStageStatus = "Ready for Final Approval";
      appBgColor = "#1976d2";
    }
  } else if (
    appStatus == "Approved" ||
    appStatus == "Completed" ||
    appStatus == "Closed"
  ) {
    appStage = "Approved";

    let attachAttrs = record.attachAttrs;
    if (attachAttrs?.executeStatus == "Closing Dos Received") {
      appStageStatus = "Signature Completed";
      appBgColor = "#1976d2";
    } else if (attachAttrs?.executeStatus == "ID check failed") {
      appStageStatus = "Signature Failed";
      appBgColor = "#fff1da";
    } else {
      appStageStatus = "Pending Signature";
      appBgColor = "#fff1da";
    }

    if (
      attachAttrs.payment_type == "ACH" ||
      attachAttrs.payment_type == "DISBURSEMENT"
    ) {
      if (!attachAttrs?.hasPaymentMethod) {
        appStageAch = "Pending ACH";
      } else {
        appStageAch = "ACH Completed";
      }
      if (
        attachAttrs.fund_status != "DISBURSEMENT_FUNDED" &&
        attachAttrs.fund_status != "COMPLETED" &&
        attachAttrs.disbursement_status != "no disbursement"
      ) {
        //disburse button should show
        if (record.sDisbursementPayment == "SMART_ACH_Vendor") {
          if (attachAttrs.vendorVerifyStatus == "Purchase Completed") {
            appStageDisbursement = "Pending Disbursement";
          }
        } else {
          appStageDisbursement = "Pending Disbursement";
        }
      } else {
        appStageDisbursement = "Disbursement Completed";
      }
      if (attachAttrs.disbursement_status == "no disbursement") {
        appStageDisbursement = "Disbursement Completed";
      }
    } else {
      if (attachAttrs.disbursement_time != "inception") {
        appStageDisbursement = "No Disbursement";
      }
    }
  } else if (appStatus == "Funded") {
    appStage = "Funded";
    appStageStatus = "";
    appBgColor = "#1976d2";
  } else {
    appStage = "Not Under Review";
    if (
      appStatus == "Hold" ||
      appStatus == "hold" ||
      appStatus == "On Hold" ||
      appStatus == "on hold"
    ) {
      appStageStatus = "On Hold";
      appBgColor = "#fff1da";
    } else if (appStatus == "expired" || appStatus == "Expired") {
      appStageStatus = "Expired";
      appBgColor = "#d32f2f";
    } else if (appStatus == "Declined" || appStatus == "declined") {
      appStageStatus = "Declined";
      appBgColor = "#d32f2f";
    } else {
      appStageStatus = "Incomplete";
      appBgColor = "#00000014";
    }
  }

  // return appStage + " " + appStageStatus;
  return (
    <Typography
      variant="body2"
      color="textSecondary"
      sx={{
        mb: 1,
        fontWeight: "bold",
        backgroundColor: appBgColor || "#fff3cd",
        color:
          appBgColor == "#00000014" || appBgColor == "#fff1da"
            ? "black"
            : "white",
        p: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        height: "60px",
      }}
    >
      {appStage}
      {appStageStatus ? (
        <>
          <br />
          {appStageStatus}
        </>
      ) : (
        ""
      )}
      {/* {appStatus == "Approved" || appStatus == "Completed" ? (
        <>
          {appStageDisbursement ? (
            <>
              <br />
              {appStageDisbursement}
            </>
          ) : (
            ""
          )}
        </>
      ) : (
        ""
      )} */}
      {/* {appStatus == "Approved" || appStatus == "Completed" ? (
        <>
          {appStageAch ? (
            <>
              <br />
              {appStageAch}
            </>
          ) : (
            ""
          )}
        </>
      ) : (
        ""
      )} */}
    </Typography>
  );
};

export default AppStageStatus;
